import { NgModule } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import {
  BoxPlotOutline,
  CalendarOutline,
  ClockCircleFill,
  CloseCircleFill,
  CommentOutline,
  DeleteOutline,
  DownloadOutline,
  GlobalOutline,
  InstagramFill,
  InstagramOutline,
  LikeOutline,
  LockFill,
  MailOutline,
  PhoneOutline,
  PictureOutline,
  PlayCircleOutline,
  PlusCircleOutline,
  SearchOutline,
  TableOutline,
  UserOutline,
} from '@ant-design/icons-angular/icons';

@NgModule({
  imports: [
    NzIconModule.forChild([
      InstagramOutline,
      InstagramFill,
      SearchOutline,
      PlusCircleOutline,
      BoxPlotOutline,
      TableOutline,
      PlayCircleOutline,
      UserOutline,
      PhoneOutline,
      MailOutline,
      GlobalOutline,
      LockFill,
      ClockCircleFill,
      CloseCircleFill,
      LikeOutline,
      CommentOutline,
      PictureOutline,
      CalendarOutline,
      DeleteOutline,
      DownloadOutline,
    ]),
  ],
})
export class IconModule {}
